import React from "react";
import { serverStrftime } from "src/utils/dates";

const DateField = ({ value }) => <span>{serverStrftime(value)}</span>;

export default DateField;
